const producto = {
  createProducto: 'producto',
  createProductoVidroop: 'producto-vidroop',
  createProductoAutoresponderListas: 'producto/{{uuid_producto}}/autoresponders',
  createProductoClonar: 'producto/{{uuid_producto}}/clonar',
  createProductoCodigoRastreo: 'producto/{{uuid_producto}}/codigo-rastreo',
  createProductoCuponDescuento: 'producto/{{uuid_producto}}/cupon-descuento',
  createProductoGestion: 'producto/{{uuid_producto}}/gestion',
  createProductoGestionPlan: 'producto/{{uuid_producto}}/gestion/{{id_gestion}}/plan',
  createProductoPaginaIdroop: 'pagina',
  createProductoPaginaIdroopActivarEdicion: 'pagina/{{uuid_pagina}}/activar-edicion',
  deleteProducto: 'producto/{{uuid_producto}}',
  deleteProductoAutoresponderLista: 'producto/{{uuid_producto}}/autoresponders',
  deleteProductoCodigoRastreo: 'producto/{{uuid_producto}}/codigo-rastreo/{{id_codigo}}',
  deleteProductoCuponDescuento: 'producto/{{uuid_producto}}/cupon-descuento/{{uuid_cupon_descuento}}',
  deleteProductoGestionPlan: 'producto/{{uuid_producto}}/gestion/{{id_producto_gestion}}/plan/{{id_producto_gestion_plan}}',
  deleteProductoPaginaIdroop: 'pagina/{{uuid_pagina}}',
  readProducto: 'producto/{{uuid_producto}}',
  readProductoAutorespondersListas: 'producto/{{uuid_producto}}/autoresponders',
  readProductoCategorias: 'producto/categorias',
  readProductoCantidadAlumnos: 'producto/{{uuid_producto}}/cantidad-alumnos',
  readProductoCodigosRastreo: 'producto/{{uuid_producto}}/codigos-rastreo',
  readProductoCuponesDescuento: 'producto/{{uuid_producto}}/cupones-descuento',
  readProductoMiniaturaVideo: 'video/thumbnail',
  readProductoGestiones: 'producto/{{uuid_producto}}/gestiones',
  readProductoPaginasIdroop: 'pagina/{{uuid_producto}}/{{tipo}}',
  readProductoPaginasIdroopListadoCompleto: 'pagina/{{uuid_academia}/listado_completo/{{tipo}}/{{pagina}}/{{limite}}',
  readProductoPlantillasIdroop: 'plantillas/{{tipo}}',
  readProductoProyectos: 'producto/{{uuid_producto}}/proyectos', /* falta en postman */
  readProductos: 'productos/{{uuid_academia}}',
  readProductosVidroop: 'productos-vidroop',
  updateProducto: 'producto/{{uuid_producto}}',
  updateProductoCodigoRastreo: 'producto/{{uuid_producto}}/codigo-rastreo/{{id_codigo}}',
  updateProductoCuponDescuento: 'producto/{{uuid_producto}}/cupon-descuento/{{uuid_cupon_descuento}}',
  updateProductoGestion: 'producto/{{uuid_producto}}/gestion/{{id_gestion}}/punto-venta',
  updateProductoGestionEstado: 'producto/{{uuid_producto}}/gestion/{{id_gestion}}/estado',
  updateProductoGestionPasarelaEstado: 'producto/{{uuid_producto}/gestion/{{id_gestion}/pasarela/{{id_gestion}}/estado',
  updateProductoPaginaIdroop: 'pagina/{{uuid_pagina}}',
  updateProductoPaginaIdroopDesactivar: 'pagina/{{uuid_pagina}}/desactivar', /* error de url en postman */
  updateProductoPaginaIdroopPublicar: 'pagina/{{uuid_pagina}}/publicar/{{primaria}}',
  updateProductoProyectos: 'producto/{{uuid_producto}}/proyectos',
  updateProductosOrdenar: 'productos/ordenar'
}

export default producto
